import { useCallback } from 'react';
import { getDepartmentProjectsList } from '@Store/selectors/dictionarySelector';
import { useAppSelector } from '.';

interface ReturnedValue {
  findDeptProjName: (
    deptProjId: number | null,
    wlId: number | null
  ) => string | null;
}

const useDeptProjectName = (): ReturnedValue => {
  const dictionaryTypes = useAppSelector(getDepartmentProjectsList);

  const findDeptProjName = useCallback(
    (deptProjId: number | null, wlId: number | null): string | null => {
      if (deptProjId === null || wlId === null) {
        return null;
      }

      const matchedProjDeptName = dictionaryTypes.find(
        (item) => item.projDeptID === deptProjId && item.wlId === wlId
      )?.projDeptName;

      return matchedProjDeptName || null;
    },
    [dictionaryTypes]
  );

  return { findDeptProjName };
};

export default useDeptProjectName;
